import { searchMerchantsQueryDocument } from 'APIs/graphql';
import { updateMerchantPayoutStatus } from 'APIs/merchants/merchants';
import { PayoutStatusUpdateRequest } from 'APIs/merchants/merchants.types';
import { Input } from 'Constants/styles';
import { ChangeEvent, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useQuery } from 'urql';
import getErrorMessage from 'utils/getErrorMessage';

import MerchantsDataTable from './MerchantsDataTable';
import { PayoutStatusHeader, SearchWrapper } from './styles';

const TogglePayoutStatus = () => {
  const { apiBaseUri } = useSelector((state: ReduxStateType) => ({
    apiBaseUri: state.apiBaseUri,
  }));

  const first = 20;
  const [query, setQuery] = useState<string>('');

  const [{ fetching, data, error: payoutsError }, reexecuteQuery] = useQuery({
    query: searchMerchantsQueryDocument,
    variables: { first, query },
    pause: !query,
  });

  const handleChangeBusinessName = (e: ChangeEvent<HTMLInputElement>): void => {
    setQuery(e.target.value);
  };

  const togglePayoutStatus = useCallback(
    async (merchantId: string, payoutStatus: string) => {
      if (!merchantId) return;

      const toggleStatus = payoutStatus === 'Enabled' ? 'Disabled' : 'Enabled';

      if (
        window.confirm(
          `Are you sure you want to ${toggleStatus.toLocaleLowerCase()} automated payouts for merchant: ${merchantId}`,
        )
      ) {
        try {
          const payoutStatusUpdateRequest: PayoutStatusUpdateRequest = {
            payoutStatus: toggleStatus,
          };
          await updateMerchantPayoutStatus(apiBaseUri, merchantId, payoutStatusUpdateRequest);
          reexecuteQuery({ requestPolicy: 'network-only' });
          toast.success(`${toggleStatus} automated payouts for merchant #${merchantId}`);
        } catch (e) {
          toast.error(`Error: ${getErrorMessage(e)}`);
        }
      }
    },
    [apiBaseUri, reexecuteQuery],
  );

  return (
    <div style={{ width: '100%' }}>
      <PayoutStatusHeader>
        <h3>Merchant payout status</h3>
        <SearchWrapper>
          <Input type="text" placeholder="Business name" onChange={handleChangeBusinessName} />
        </SearchWrapper>
      </PayoutStatusHeader>
      <MerchantsDataTable
        merchantsList={query ? data?.merchants?.edges.map((edge) => edge.node) : []}
        isErrorRequest={payoutsError !== undefined}
        togglePayoutStatus={togglePayoutStatus}
        fetchListLoader={fetching}
      />
    </div>
  );
};

export default TogglePayoutStatus;
